import { Grid, styled } from '@mui/material';
import { FC } from 'react';
import { WidgetsData } from '../../WidgetRow';

const Picture = styled('picture')`
	border-radius: 4px;
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: block;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		overflow: hidden;
	}
`;

type Props = Readonly<{
	pictures: WidgetsData['pictures'];
	handlePictureClick?: (index: number) => void;
}>;

export const SimplePictureGrid: FC<Props> = ({ pictures, handlePictureClick }) => {
	return (
		<Grid display={'grid'} gridTemplateColumns={`repeat(${getColumnsCount(pictures.length)}, 1fr)`} container gap={0.75}>
			{pictures.map((picture, i) =>
				picture.image?.url ? (
					<Picture
						key={picture.id}
						onClick={() => handlePictureClick?.(i)}
						sx={{
							aspectRatio: pictures.length === 1 ? '16/9' : '4/3',
							maxHeight: pictures.length === 1 ? 250 : 'initial',
							border: '1px solid',
							cursor: handlePictureClick ? 'pointer' : 'initial',
							borderColor: (theme) => theme.palette.divider,
						}}
					>
						<img src={picture.image.url} alt={picture.image.id} />
					</Picture>
				) : null,
			)}
		</Grid>
	);
};

const getColumnsCount = (amount: number) => Math.min(amount, 3);
